import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { cloneDeep, isObject, isEmpty } from 'lodash';
import { Logger } from '../services';

export const logInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(Logger);
  const reqClone = cloneDeep(req) as HttpRequest<unknown>;

  const { body, params } = reqClone;

  if (isObject(body) && !isEmpty(body)) {
    Object.keys(body).forEach((key) => {
      const value = body[key];

      logger.logIfFalsy(value, `Http request body: key ${key}`);
    });
  }

  if (params) {
    const keys = params.keys();

    if (!keys.length) return next(req);

    keys.forEach((key) => {
      const param = params.get(key);

      logger.logIfFalsy(param, `Http request param (${key}) for endpoint ${reqClone.url}`);
    });
  }

  return next(req);
};
